export default __webpack_public_path__ + "static/media/atpar1.39d10356.png";